import React from 'react';
import styled, { css } from 'styled-components';

import priceWithCurrency from '../functions/priceWithCurrency';
import { Title, Label } from '../helpers/Text';
import Types from '../../../modules/types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Price = styled(Label)`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;

  ${({ size }) => size === 'large' && css`
    font-size: 16px;
    font-weight: 600;
  `}
`;

const PriceLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
`;

const PriceDivider = styled(Label)`
  opacity: 0.25;
  margin-bottom: 5px;
  text-decoration: none;
`;

PriceDivider.defaultProps = {
  children: '- - -',
};

const Footer = ({ order }) => {
  const { systemCountry } = order;
  const { VAT } = Types.getSystemCountry(systemCountry);
  const discountTotal = (
    order?.discountCode?.amountFull
    || order?.discountCode?.amountShippingAndPaymentFull
  )
    ? order.cost.total
    : order.cost.total
      * (order?.discountCode?.amountPercentage / 100 || 0)
      - (order?.discountCode?.amountFixed || 0);

  const priceTotal = order.cost.total - discountTotal;

  return (
    <Wrapper>

      <div style={{ height: 40 }} />
      <div style={{ borderBottom: '1px solid #eee' }} />
      <div style={{ height: 30 }} />

      <Title key="title" fontSize={32} style={{ margin: 0 }}>
        Total
      </Title>

      <PriceDivider key="start" />

      <Price key="products" as="p">
        <PriceLabel as="span">Products: </PriceLabel>
        {priceWithCurrency(order.cost.total, order.store)}
      </Price>

      {discountTotal !== 0 ? (
        <Price key="discount">
          <PriceLabel>Discount: </PriceLabel>
          {priceWithCurrency(discountTotal, order.store)}
        </Price>
      ) : null}

      {order.store.trn.active ? (
        <Price key="vat">
          <PriceLabel>VAT: </PriceLabel>
          {priceWithCurrency(priceTotal * VAT, order.store)}
        </Price>
      ) : null}

      {order.cost.payment !== 0 ? (
        <Price key="payment">
          <PriceLabel>Payment: </PriceLabel>
          {priceWithCurrency(order.cost.payment, order.store)}
        </Price>
      ) : null}

      <PriceDivider key="end" />

      <Price key="charged" lineHeight="30px" size="large">
        {order.store.trn.active
          ? priceWithCurrency(priceTotal * (1 + VAT), order.store)
          : priceWithCurrency(priceTotal, order.store)}
      </Price>

      <div style={{ height: 5 }} />
    </Wrapper>
  );
};

export default Footer;
